document.addEventListener('DOMContentLoaded', function() {
  // Mapping of 48 continental states to transit times from Charleston, SC (+1 day added for warehouse packing prep)
  const transitTimes = {
    'AL': '3-4', 'AZ': '5-6', 'AR': '4-5', 'CA': '5-6', 'CO': '5-6',
    'CT': '4-5', 'DE': '3-4', 'FL': '3-4', 'GA': '2-3', 'ID': '5-6',
    'IL': '4-5', 'IN': '4-5', 'IA': '4-5', 'KS': '4-5', 'KY': '3-4',
    'LA': '4-5', 'ME': '4-5', 'MD': '3-4', 'MA': '4-5', 'MI': '4-5',
    'MN': '4-5', 'MS': '4-5', 'MO': '4-5', 'MT': '5-6', 'NE': '4-5',
    'NV': '5-6', 'NH': '4-5', 'NJ': '4-5', 'NM': '5-6', 'NY': '4-5',
    'NC': '2-3', 'ND': '5-6', 'OH': '4-5', 'OK': '4-5', 'OR': '5-6',
    'PA': '4-5', 'RI': '4-5', 'SC': '2-3', 'SD': '5-6', 'TN': '3-4',
    'TX': '4-5', 'UT': '5-6', 'VT': '4-5', 'VA': '3-4', 'WA': '5-6',
    'WV': '3-4', 'WI': '4-5', 'WY': '5-6'
  };

  // State code to full state name mapping
  const stateNames = {
    'AL': 'Alabama', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California', 'CO': 'Colorado',
    'CT': 'Connecticut', 'DE': 'Delaware', 'FL': 'Florida', 'GA': 'Georgia', 'ID': 'Idaho',
    'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas', 'KY': 'Kentucky',
    'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland', 'MA': 'Massachusetts', 'MI': 'Michigan',
    'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska',
    'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
    'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma', 'OR': 'Oregon',
    'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina', 'SD': 'South Dakota', 'TN': 'Tennessee',
    'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington',
    'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming'
  };

  function applyGeotargeting(city, regionCode, country) {
    const isContinentalUS = country === 'US' && transitTimes.hasOwnProperty(regionCode);
    
    // Find all shipping message containers
    const messageContainers = document.querySelectorAll('.geo-shipping-msg');
    
    messageContainers.forEach(function(container) {
      if (isContinentalUS) {
        const transit = transitTimes[regionCode];
        const stateName = stateNames[regionCode];
        
        container.innerHTML = `
          <div style="font-size: 11.5px; color: #a1a1aa; line-height: 1.4; display: flex; align-items: center; gap: 6px;">
            <span style="font-size: 13px;">🚚</span>
            <span>
              <strong>Local Delivery to ${stateName}:</strong> $250 flat-rate freight shipping to ${city} & surrounding areas in <strong>${transit} business days</strong> (inclusive of 1-day warehouse packing prep).<br><br><span style="color: #50c6aa; font-weight: bold;">Service Certified</span> - All boards ship pre-paired and fully updated.
            </span>
          </div>
        `;
      } else {
        // Fallback for HI, AK, or international visitors
        container.innerHTML = `
          <div style="font-size: 11.5px; color: #a1a1aa; line-height: 1.4; display: flex; align-items: center; gap: 6px;">
            <span style="font-size: 13px;">📦</span>
            <span>
              <strong>Insured Freight Shipping:</strong> $250 flat-rate shipping across the Continental US.<br><br><span style="color: #50c6aa; font-weight: bold;">Service Certified</span> - All boards ship pre-paired and fully updated. Contact support for AK/HI rates.
            </span>
          </div>
        `;
      }
    });

    // Also update any standalone location placeholders on page (like a page header or banner)
    const locationElements = document.querySelectorAll('.geo-location-name');
    locationElements.forEach(function(el) {
      if (isContinentalUS) {
        el.textContent = city + ', ' + regionCode;
      }
    });
  }

  // Check if location is already cached in session
  const cachedCity = sessionStorage.getItem('geo_city');
  const cachedRegion = sessionStorage.getItem('geo_region');
  const cachedCountry = sessionStorage.getItem('geo_country');

  if (cachedCity && cachedRegion && cachedCountry) {
    applyGeotargeting(cachedCity, cachedRegion, cachedCountry);
  } else {
    // Fetch user location via a fast, lightweight geolocation API
    fetch('https://ipwhois.app/json/')
      .then(response => response.json())
      .then(data => {
        if (data && data.success) {
          const city = data.city || 'your area';
          const region = data.region_code || '';
          const country = data.country_code || '';
          
          // Cache in session storage
          sessionStorage.setItem('geo_city', city);
          sessionStorage.setItem('geo_region', region);
          sessionStorage.setItem('geo_country', country);
          
          applyGeotargeting(city, region, country);
        } else {
          applyGeotargeting('your area', '', 'US'); // default US fallback
        }
      })
      .catch(err => {
        console.warn('Geolocation lookup failed, falling back to default:', err);
        applyGeotargeting('your area', '', 'US');
      });
  }
});
